export default __webpack_public_path__ + "static/2-for-buyers-mobile-31adfc4f717caea98dc1cc0581399d38.jpg";